import React, { useContext, useEffect, useState } from "react";
import LoadingSpinner from "../components/common/LoadingSpinner";
import { httpReauest } from "../utils/httpRequest";
import { Link, useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaShoppingCart,
  FaUtensils,
  FaHome,
  FaGamepad,
  FaUser,
} from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import Layout from "../components/layout";
import AddressModal from "../components/common/modal/AddressModal";
import { ArrowDown2, Send2, Timer, Timer1 } from "iconsax-reactjs";
import ProductCard from "../components/common/card/ProductCard";
import { useTranslation } from "react-i18next";
import LangugeChanger from "../components/common/LangugeChanger";
import Loading from "../components/common/Loading";
import { useCart } from "../context/CartContext";

const Restaurant = () => {
  const [loading, setLoading] = useState(true);
  const [addressModal, setaddressModal] = useState();
  const [products, setProducts] = useState([]);
  const [data, setdata] = useState();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const navigate = useNavigate();

  const { cartItems, updateQuantity, resetCart } = useCart();

  const { t, i18n } = useTranslation();

  useEffect(() => {
    getData();
    getCategories();
    getProducts(); // همه محصولات بدون فیلتر
  }, []);

  async function getData() {
    const user = JSON.parse(localStorage.getItem("user"));
    // if (!user) {
    //   navigate("/login");
    // }
    await httpReauest("GET", "/user/info/" + user?._id, {}, {})
      .then((res) => setdata(res.data.data?.user))
      .catch(() => {
        localStorage.removeItem("user");
        // navigate("/login");
      });
    setLoading(false);
  }

  async function getCategories() {
    try {
      const res = await httpReauest("GET", "/category");
      setCategories(res.data.data); // فرض بر اینکه `res.data.data` یک آرایه از دسته‌بندی‌هاست
    } catch (error) {
      console.error("خطا در دریافت دسته‌بندی:", error);
    }
  }

  async function getProducts(categoryId = null) {
    setLoading(true);
    let query = "/product";
    if (categoryId) {
      query += `?category=${categoryId}`;
    }

    try {
      const res = await httpReauest("GET", query);
      setProducts(res.data.data.data); // دسترسی به لیست محصولات
    } catch (error) {
      console.error("خطا در دریافت محصولات:", error);
    }

    setLoading(false);
  }

  return (
    <div className="min-h-screen flex flex-col justify-between text-[var(--primary)]">
      <AddressModal
        show={addressModal}
        setShow={setaddressModal}
        getData={getData}
        selectedAddress={data?.selectedAddress?._id}
      />
      <Layout>
        <div className="flex fixed max-w-[768px] mx-auto z-50 top-0 left-0 right-0 w-full items-center justify-between px-4 py-3 bg-yellow-200 shadow">
          <LangugeChanger />

          <button
            onClick={() => setaddressModal(true)}
            className="flex items-center space-x-1 text-sm font-semibold text-green-800 cursor-pointer"
          >
            <MdLocationOn className="text-lg" />
            <span>
              {data?.selectedAddress
                ? data?.selectedAddress?.name
                : "Select An Address"}
            </span>
            <ArrowDown2 size={16} />
          </button>

          <Link to={"/cart"} className="text-xl relative">
            <FaShoppingCart />
            <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs px-1 rounded-full">
              {cartItems.length ? cartItems.length : "0"}
            </span>
          </Link>
        </div>

        <div className="mt-[44px]">
          <img
            src="/banner.jpg"
            className="h-[160px] object-cover w-full"
            alt="Sambite Logo"
          />
        </div>

        <main className="py-4 pb-16 relative">
          <div className="text-center py-2">
            <img
              src="/logo.png"
              className="w-[100px] mx-auto"
              alt="Sambite Logo"
            />
          </div>

          <div className="flex gap-2 items-center max-w-[100vw] text-black overflow-x-auto py-2 px-2 bg-white shadow">
            <span className="text-[12px] py-1 px-3 rounded-full flex gap-2 items-center bg-white border whitespace-nowrap">
              <Timer1 size={16} />
              {t("restaurant_delivery_time")}
            </span>
            <span className="text-[12px] py-1 px-3 rounded-full flex gap-2 items-center bg-white border whitespace-nowrap">
              <Send2 size={16} />
              {t("restaurant_delivery_price")}
            </span>
          </div>

          <div className="flex sticky top-[44px] z-40 gap-2 items-center max-w-[100vw] text-black overflow-x-auto py-2 px-2 bg-white shadow mt-2">
            <span
              className={`text-[14px] py-1 px-3 rounded-full flex gap-2 items-center cursor-pointer ${
                !selectedCategory ? "bg-[var(--primary)]" : "bg-white"
              }`}
              onClick={() => {
                setSelectedCategory(null);
                getProducts();
              }}
            >
              {t("all")}
            </span>

            {categories.map((category) => (
              <span
                key={category._id}
                className={`text-[14px] py-1 px-3 rounded-full flex gap-2 items-center cursor-pointer whitespace-nowrap ${
                  selectedCategory === category._id
                    ? "bg-[var(--primary)]"
                    : "bg-white border"
                }`}
                onClick={() => {
                  setSelectedCategory(category._id);
                  getProducts(category._id);
                }}
              >
                {i18n.language === "en" ? category.name_en : category.name}
              </span>
            ))}
          </div>

          <div className="p-4">
            {loading ? (
              <Loading />
            ) : (
              products.map((item) => (
                <ProductCard key={item.id} product={item} />
              ))
            )}
          </div>
        </main>
      </Layout>
    </div>
  );
};

export default Restaurant;
